module.exports = __webpack_public_path__ + "static/fiddlersGreen-feb7a5a94f64139bdc19310440f7d6c9.jpg";